<!-- Display loading message when data is being fetched -->
<div class="draft-loader" *ngIf="isLoading">
  <app-ltms-loader></app-ltms-loader>
</div>
<div class="currently-live-version-card" *ngIf="!isLoading && liveVersionDetails && liveVersionDetails.version">
  <div class="header">
    <!-- <i class="fa fa-info-circle version-icon"></i> -->
    <img class="version-icon" src="assets/images/engagement-banner-image.svg" alt="loudspeaker">
    <!-- <div class="version-info">
      <h3>Currently Live Version</h3>
      <span class="live-tag status-tag">Live</span>
    </div> -->
     <div class="details">
      <div class="live-version-info"><p><strong>Live Version {{ liveVersionDetails?.version }}</strong></p>
    <span class="divider">|</span>
    <p><strong>Published on {{ liveVersionDetails?.published | date:"dd-MMM-yy 'at' HH:mm" }}</strong></p>
    <!-- <span class="divider">|</span>
    <p><strong>Published By {{ liveVersionDetails?.published_by }}</strong></p> -->
    <!-- <p *ngIf="liveVersionDetails?.created_from"><strong>Created From:</strong> {{ liveVersionDetails?.created_from }}
    </p> -->
  </div>
      <div> <p class="info-message">This is the version currently visible to conversation respondents. Any changes made in the
    editor will not affect this live version until you explicitly publish a new version.</p></div>
   </div>
  </div>
</div>
<div class="version-history-container">

<div class="litmus-intraction-container" *ngIf="!isLoading">
  <!-- <div class="drafts-header">
    <h3>Version History</h3>
  </div> -->
  <div class="search-pagination-container" *ngIf="isDataAvailable">
  <div class="drafts-header">
    <h3>Version History</h3>
  </div>
    <!-- Pagination controls --> 
   <div class="pagination-controls">
   <div class="search-box">
   <i class="fa fa-search search-icon"></i>
   <input type="text" [(ngModel)]="searchQuery" (keyup.enter)="onSearch()" placeholder="Type your input, then press Enter" (ngModelChange)="onSearchQueryChange($event)" title="Type and press Enter to search">
   <button class="clear-button" *ngIf="searchQuery" (click)="clearSearch()"  >
    <i class="fa fa-times"></i>
   </button>
   </div>

   <!-- First Page -->
   <button *ngIf="isDataAvailable && versionList && versionList.length > 0"
    (click)="goToFirstPage()"
    [disabled]="pageNumber === 1">
    <img src="assets/images/chevron-double-left.svg" alt="First">
   </button>

   <!-- Previous Page -->
   <button *ngIf="isDataAvailable && versionList && versionList.length > 0"
    (click)="pageMove('previous')"
    [disabled]="pageNumber === 1">
    <img src="assets/images/chevron-left.svg" alt="Previous">
   </button>

   <div class="pagination-text" *ngIf="isDataAvailable && versionList && versionList.length > 0">
    {{ (pageNumber - 1) * 10 + 1 }} - {{ (pageNumber - 1) * 10 + versionList.length }} of {{ totalVersionListCount }}
   </div>

    <!-- Next Page -->
    <button *ngIf="isDataAvailable && versionList && versionList.length > 0"
      (click)="pageMove('next')"
      [disabled]="!hasNextPage">
      <img src="assets/images/chevron-right.svg" alt="Next">
    </button>

    <!-- Last Page -->
    <button *ngIf="isDataAvailable && versionList && versionList.length > 0"
      (click)="goToLastPage()"
      [disabled]="!hasNextPage">
      <img src="assets/images/chevron-double-right.svg" alt="Last">
    </button>
  </div>

  </div>
</div>
<!-- Table to display version data -->
<div class="table-responsive version-table"
  *ngIf="!isLoading && isDataAvailable && versionList && versionList.length > 0">
  <div class="table-overlay" *ngIf="isTableLoading">
    <app-ltms-loader></app-ltms-loader>
  </div>
  <div class="error-message" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
  <table>
    <thead>
      <tr>
        <th>Version</th>
        <th>Created On</th>
        <th>Created By</th>
        <th>Source Version</th>
        <th>Status</th>
        <th>Preview</th>
        <th class="action-header-cell">Actions</th>
      </tr>
    </thead>
    <tbody>
      <!-- Iterate through versionList to create table rows -->
      <tr *ngFor="let version of versionList; let i = index"  
  [class.selected]="selectedRow === i">
        <td>{{ version.version }}</td>
        <td>{{ version['created_date'] }}</td>
        <td>{{ version['created_by'] }}</td>
        <td>{{ version['source_version'] }}</td>
        <td class="status-tag-container">
          <span *ngIf="version.status === 'Live'" class="live-tag status-tag">Live</span>
          <span *ngIf="version.status !== 'Live'" class="draft-tag status-tag">Draft</span> 
        </td>
        <td [innerHTML]="version['preview']">
        </td>
        <td class="action-column-cell">
        <button 
  [class.hidden-button]="version.status === 'Live'"
  (click)="onRestoreAndPublish(i, version.version)"
  [disabled]="!isUserHasWriteAccess"
  class="publish-restore-button">
  {{ i === 0 && pageNumber === 1 && version.status !== 'Live' ? 'Publish' : 'Restore & Publish' }}
</button>
          <button [class.hidden-button]="version.version == latestVersionNumber"
            [disabled]="!isUserHasWriteAccess"
            (click)="restoreSelectedVersion(version.version, i)" class="restore-button">Restore</button>
        </td>
      </tr>
    </tbody>
  </table>
</div> 
</div>
<!-- Display message if no data is available -->
<div class="no-data-container" *ngIf="!isLoading && (!isDataAvailable || !versionList || versionList.length === 0)">
  <div class="no-data-message">
    No version data available.
  </div>
</div>
<!-- Custom Alert Modal Structure -->
<div class="custom-alert-overlay" *ngIf="showAlert">
  <div class="custom-alert-modal">
    <div class="custom-alert-header">
      <h3 class="custom-alert-title">{{ alertTitle }}</h3>
    </div>
    <div class="custom-alert-body">
      <p *ngFor="let message of alertMessages" [innerHTML]="message"></p>
    </div>
    <div class="custom-alert-footer">
      <button class="btn btn-secondary" (click)="onAlertCancel()">{{ alertCancelText }}</button>
      <button class="btn btn-primary" (click)="onAlertConfirm()">{{ alertConfirmText }}</button>
    </div>
  </div>
</div>